import React, { createContext, useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";

import Login from "./Componants/Auth/Login";
import Home from "./Componants/Home/Home";
import SideNav from "./Componants/Side Navbar/SideNav";
import Navbar from "./Componants/Navbar/Navbar";
import PromiseVoucher from "./Componants/Voucher/PromiseVoucher";
import Relationcategory from "./Componants/Relation Category/Relationcategory";
import FilterCategory from "./Componants/Filter Category/FilterCategory";
import OccassionCategory from "./Componants/Occassion Category/OccassionCategory";
import Profile from "./Componants/Profile/Profile";
import UserManagement from "./Componants/User Management/UserManagement";
import GlobalOccassions from "./Componants/Global Occasions/GlobalOccassions";
import Terms from "./Componants/Terms & Conditions/Terms";
import HelpAndSupport from "./Componants/Help & Support/HelpAndSupport";
import Billing from "./Componants/Billing & Subscription/Billing";
import Notifications from "./Componants/Notifications/Notifications";
import AdminNotifications from "./Componants/Notifications/AdminNotifications";
import Query from "./Componants/Query/Query";
import VoucherTracking from "./Componants/Voucher Tracking/VoucherTracking";
import ActiveUsers from "./Componants/Home/ActiveUsers";
import InActiveUsers from "./Componants/Home/InactiveUsers";
import LayoutCategory from "./Componants/Layout/Layouts";
import { HostedPolicies } from "./Componants/HostedPolicies";
import DeepLink from "./Componants/DeepLink";

export const UserContext = createContext();

function App() {
  const [isOpen, setIsOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    localStorage.getItem("token") ? true : false
  );

  document.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });

  const toggleSidenav = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <Router>
      <UserContext.Provider value={{ setIsAuthenticated, isAuthenticated }}>
        {isAuthenticated ? (
          <AuthenticatedApp isOpen={isOpen} toggleSidenav={toggleSidenav} />
        ) : (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/policies" element={<HostedPolicies />} />
            <Route path="/open-app/*" element={<DeepLink />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        )}
      </UserContext.Provider>
    </Router>
  );
}

const AuthenticatedApp = ({ isOpen, toggleSidenav }) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="flex h-screen">
      {!["/policies", "/open-app/*"].includes(path) && (
        <SideNav isOpen={isOpen} />
      )}

      <div
        className={`flex-1 transition-all duration-300 ${
          isOpen && !["/policies", "/open-app/*"].includes(path)
            ? "ml-64"
            : "ml-0"
        }`}
      >
        {!["/policies", "/open-app/*"].includes(path) && (
          <Navbar toggleSidenav={toggleSidenav} />
        )}
        <Routes>
          <Route path="*" element={<Navigate to="/home" />} />
          <Route path="/open-app/*" element={<DeepLink />} />
          <Route path="/policies" element={<HostedPolicies />} />
          <Route path="/home" element={<Home />} />
          <Route path="/voucher" element={<PromiseVoucher />} />
          <Route path="/filter" element={<FilterCategory />} />
          <Route path="/occassion" element={<OccassionCategory />} />
          <Route path="/relation" element={<Relationcategory />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/global-occasions" element={<GlobalOccassions />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/help-&-support" element={<HelpAndSupport />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/admin-notifications" element={<AdminNotifications />} />
          <Route path="/query" element={<Query />} />
          <Route path="/voucher-tracking" element={<VoucherTracking />} />
          <Route path="/Layout-Category" element={<LayoutCategory />} />
          <Route path="/active-users" element={<ActiveUsers />} />
          <Route path="/in-active-users" element={<InActiveUsers />} />

          {/* <Route path='/profile' element={<Profile />} />
    <Route path='/admin' element={<Admin/>}/>
    <Route path='/FAQ/admin' element={<AdminFaq/>}/>
    <Route path='/FAQ/employee' element={<EmployeeFaq/>}/>
    <Route path='/about-us' element={<About/>}/>
    <Route path='/privacy-policy' element={<Privacy/>}/>
    <Route path='/terms-conditions' element={<Terms/>}/> */}
        </Routes>
      </div>
    </div>
  );
};

export default App;
